import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
    // Scroll to the top when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Placeholder date for the policy
    const effectiveDate = "15 نوفمبر 2025";
    const appName = "منصة طفلي المبدع";

    return (
        <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8" dir="rtl">
            <header className="text-center mb-10">
                <h1 className="text-4xl font-extrabold text-blue-700 sm:text-5xl border-b-4 border-blue-200 pb-3">
                    سياسة الخصوصية
                </h1>
                <p className="mt-4 text-gray-600 text-lg">
                    تاريخ السريان: {effectiveDate}
                </p>
            </header>

            <section className="space-y-8 text-gray-700">
                {/* --- 1. المقدمة --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-blue-500">
                    <h2 className="text-2xl font-bold mb-3 text-blue-600">
                        1. المقدمة
                    </h2>
                    <p>
                        نحن في **{appName}** نولي أهمية قصوى لخصوصية مستخدمينا. توضح هذه السياسة كيفية جمعنا واستخدامنا وحمايتنا لمعلوماتك الشخصية عند استخدامك لخدماتنا. باستخدامك لتطبيقنا، فإنك توافق على شروط هذه السياسة.
                    </p>
                </div>

                {/* --- 2. المعلومات التي نجمعها --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-blue-500">
                    <h2 className="text-2xl font-bold mb-3 text-blue-600">
                        2. المعلومات التي نجمعها
                    </h2>
                    <p className="mb-3">
                        قد نجمع أنواعاً مختلفة من المعلومات لتقديم وتحسين خدماتنا لك:
                    </p>
                    <ul className="list-disc pr-6 space-y-2">
                        <li>
                            **بيانات الاستخدام:** معلومات حول كيفية وصولك واستخدامك للتطبيق، مثل الدروس التي أكملتها، والوقت الذي تقضيه في كل تمرين، وتفاعلاتك داخل التطبيق.
                        </li>
                        <li>
                            **المعلومات المقدمة طواعية:** أي بيانات تدخلها بنفسك، مثل اسم المستخدم (إن وجد) أو أي إجابات أو مدخلات في التمارين التعليمية.
                        </li>
                        <li>
                            **بيانات الجهاز:** معلومات حول جهازك المحمول أو الكمبيوتر، مثل نظام التشغيل ونوع الجهاز.
                        </li>
                    </ul>
                </div>

                {/* --- 3. كيف نستخدم معلوماتك --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-blue-500">
                    <h2 className="text-2xl font-bold mb-3 text-blue-600">
                        3. كيف نستخدم معلوماتك
                    </h2>
                    <p>
                        نستخدم البيانات المجمعة لأغراض متعددة:
                    </p>
                    <ul className="list-disc pr-6 space-y-2">
                        <li>لتقديم وصيانة خدماتنا.</li>
                        <li>لإخطارك بالتغييرات التي تطرأ على خدماتنا.</li>
                        <li>لتقديم الدعم والمساعدة للمستخدمين.</li>
                        <li>لتحليل الاستخدام بهدف تحسين خدماتنا ومحتوانا التعليمي.</li>
                        <li>لرصد الاستخدام ومنع الاحتيال أو المشكلات التقنية.</li>
                    </ul>
                </div>

                {/* --- 4. الأمان --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-blue-500">
                    <h2 className="text-2xl font-bold mb-3 text-blue-600">
                        4. أمان البيانات
                    </h2>
                    <p>
                        إن أمان بياناتك يهمنا، لكن تذكر أنه لا توجد طريقة نقل عبر الإنترنت أو طريقة تخزين إلكتروني آمنة بنسبة 100%. بينما نسعى جاهدين لاستخدام وسائل مقبولة تجارياً لحماية بياناتك الشخصية، لا يمكننا ضمان أمنها المطلق.
                    </p>
                </div>

                {/* --- 5. الاتصال بنا --- */}
                <div className="p-6 bg-white rounded-xl shadow-lg border-r-4 border-blue-500">
                    <h2 className="text-2xl font-bold mb-3 text-blue-600">
                        5. الاتصال بنا
                    </h2>
                    <p>
                        إذا كانت لديك أية أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا عبر:
                    </p>
                    <p className="mt-2 font-mono bg-gray-100 p-2 rounded">
                     omran4d@gmail.com
                    </p>
                </div>

                {/* --- Footer Link --- */}
                <div className="text-center pt-4">
                    <Link to="/" className="text-blue-500 hover:text-blue-700 font-bold transition-colors">
                        العودة إلى الصفحة الرئيسية 🏠
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Privacy;